module.exports = __webpack_public_path__ + "media/A33.cc953aaa.mp3";